export const getPartsMadeForJob = (state) => {
  return state.jobTotal;
};
